function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBtnAddAddress = function SvgBtnAddAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M903.7 456H569.3l.5-335.7c0-30.9-25-56-55.9-56h-.1c-30.9 0-55.9 25-56 55.9l-.5 335.8h-337c-30.9 0-56 25-56 56s25 56 56 56h336.9l-.5 335.7c0 30.9 25 56 55.9 56h.1c30.9 0 55.9-25 56-55.9l.5-335.8h334.6c30.9 0 55.9-25 55.9-56s-25.1-56-56-56",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgBtnAddAddress;